export function makeState(name, storageName, _a) {
    var sorting = _a.sorting, paging = _a.paging, category = _a.category, filters = _a.filters;
    var initialState = {
        filters: filters,
        paging: paging,
        sorting: sorting,
        category: category,
        list: undefined,
        isLoadingList: false,
        isInitList: false,
        item: undefined,
        isInitItem: false,
        isLoadingItem: false,
        actions: [],
        isLoadingActions: false,
        filterHistory: [],
        isErrorList: false,
        isErrorItem: false,
        loadResult: {},
        meta: {
            name: name,
            storageName: storageName,
        },
    };
    var cache = {
        filters: 0,
        paging: 0,
        sorting: 0,
        category: 0,
    };
    return { initialState: initialState, cache: cache };
}
